import { Decimal } from 'decimal.js';

// toExpNeg/toExpPos keep toString() in plain notation: decimal strings must
// round-trip through TEXT columns and DecimalString schemas without '1e-8' forms.
Decimal.set({ precision: 28, rounding: Decimal.ROUND_HALF_UP, toExpNeg: -30, toExpPos: 30 });

export type DecimalLike = Decimal | string | number;

export class InvalidDecimalError extends Error {
  override readonly name = 'InvalidDecimalError';
  constructor(value: unknown) {
    super(`Invalid decimal input: ${String(value)}`);
  }
}

export function D(value: DecimalLike): Decimal {
  if (typeof value === 'number') {
    if (!Number.isFinite(value)) {
      throw new InvalidDecimalError(value);
    }
    return new Decimal(value);
  }
  if (typeof value === 'string') {
    try {
      return new Decimal(value);
    } catch {
      throw new InvalidDecimalError(value);
    }
  }
  return value;
}

export function formatDecimal(value: Decimal, scale: number): string {
  const fixed = value.toFixed(scale, Decimal.ROUND_HALF_UP);
  return fixed.replace('.', ',');
}
